var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33333 12H6.33333V10.6667H7.66667V9.66667H6.33333V8.33333H5.33333V9.66667H4V10.6667H5.33333V12ZM8.66667 11.5H12V10.5H8.66667V11.5ZM8.66667 9.83333H12V8.83333H8.66667V9.83333ZM9.4 7.3L10.3333 6.36667L11.2667 7.3L11.9667 6.6L11.0333 5.63333L11.9667 4.7L11.2667 4L10.3333 4.93333L9.4 4L8.7 4.7L9.63333 5.63333L8.7 6.6L9.4 7.3ZM4.16667 6.13333H7.5V5.13333H4.16667V6.13333ZM3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM3.33333 12.6667H12.6667V3.33333H3.33333V12.6667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculate);
export default __webpack_public_path__ + "static/media/calculate.6b14e4e05215726735241034072c0897.svg";
export { ForwardRef as ReactComponent };